<template>
  <div class="card card-content">

    <div class="card-header">
      <div class="header">
        <div class="breadcrumb">
          <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
          <a class="breadcrumb-item" v-link="{ path: '/project/list'}">Gestion des parcours</a>
          <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.project.contact_id } }">{{ project.contact_firstname }} {{ project.contact_lastname }}</a>
          <a class="breadcrumb-item" v-link="{ name: 'editProject', params: { projectId: project.id } }">Planning</a>
        </div>
        <h1>Parcours de {{ project.contact_firstname }} {{ project.contact_lastname }}</h1>
      </div>
      <div class="actions">
        <a class="btn btn-link" v-link="{ name: 'addMeetingWithProject', params: { contactId: project.contact_id, projectId: project.id } }">Ajouter un rendez-vous</a>
      </div>
    </div>

    <div class="card-block">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editProject', params: { projectId: project.id }}">Informations</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" v-link="{ name: 'planningProject', params: { projectId: project.id }}">Planning</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-link="{ name: 'editProject.sortie', params: { projectId: project.id }}">Fiche de sortie</a>
        </li>
      </ul>
    </div>

    <div class="Calendar CalendarPlanning"></div>

    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" v-link="{ path: '/project/list'}">Voir tous les parcours</a>
      </div>
    </div>
  </div>
</template>

<script>
  // Npm imports
  import $ from 'jquery'
  import moment from 'moment'

  import 'fullcalendar'
  import 'fullcalendar/dist/locale/fr.js'

  // Vuex
  import { project as currentProject, meetingsProject, selectedDay, meetingDeleted, phases, firstintervenants, presences } from 'src/vuex/getters'

  import { getMeetingsForProject, getMeeting, selectDay } from 'src/vuex/actions/meetingActions'
  import { getProject } from 'src/vuex/actions/projectActions'
  import { getPhases } from 'src/vuex/actions/phaseActions'
  import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
  import { getPresences } from 'src/vuex/actions/presenceActions'

  import { formatMeetingsWithUrl } from 'src/utils/fullcalendar'

  // Local components
  import Breadcrumb from '../nav/Breadcrumb.vue'

  export default {
    vuex: {
      getters: { currentProject, meetingsProject, selectedDay, meetingDeleted, phases, firstintervenants, presences },
      actions: { getProject, getMeetingsForProject, getMeeting, selectDay, getPhases, getFirstintervenants, getPresences }
    },
    components: { Breadcrumb },
    data () {
      return {
        project: []
      }
    },
    ready () {
      let vm = this
      let phasetmp = 0

      this
        .getProject(this.$route.params.projectId)
        .then(() => { vm.project = JSON.parse(JSON.stringify(vm.currentProject)) })

      this.getPhases()
      this.getFirstintervenants()
      this.getPresences()

      $('.Calendar').fullCalendar({
        navLinks: false,
        editable: false,
        droppable: false,
        lazyFetching: true,
        eventLimit: true,
        header: {
          left: 'prev,next today',
          center: '',
          right: 'title'
        },
        eventClick: function (calEvent, jsEvent, view) {
          console.log('event on list ' + calEvent.id)
          vm.getMeeting(calEvent.id)
        },
        viewRender: function (view, element) {
          vm.selectDay({ time: view.intervalStart.format('DD-MM-YYYY'), origin: 'calendar' })
        },
        minTime: '06:00:00',
        maxTime: '19:00:00',
        lang: 'fr',
        views: {
          listAllYears: {
            type: 'listYear',
            duration: { years: 31 }
          }
        },
        defaultView: 'listAllYears',
        eventAfterAllRender: function (view) {
          var renderedEvents = $('.fc-list-table  tr')
          var reorderedEvents = []
          var blockEvents = null
          renderedEvents.map(function (key, event) {
            if ($(event).hasClass('fc-list-heading')) {
              if (blockEvents) {
                reorderedEvents.unshift(blockEvents.children())
              }
              blockEvents = $('<tbody></tbody>')
            }
            blockEvents.append(event)
          })
          if (blockEvents) {
            reorderedEvents.unshift(blockEvents.children())
          }
          $('.fc-list-table tbody').html(reorderedEvents)
        },
        events (start, end, timezone, callback) {
          vm.getMeetingsForProject('2000-01-01', end.format('YYYY-MM-DD'), vm.$route.params.projectId)
            .then(() => {
              let firstintervenanttmp = 0
              vm.meetingsProject.forEach(function (meeting) {
                if (meeting.title === 'null' || meeting.title === null) {
                  meeting.title = ''
                }
                phasetmp = meeting.phase_id
                vm.phases.forEach(function (phase) {
                  if (phase.id === phasetmp) {
                    meeting.title = meeting.title + ' ' + phase.name
                  }
                })
                vm.presences.forEach(function (presence) {
                  if (presence.id === meeting.presence_id) {
                    meeting.title = '(' + presence.name + ') ' + meeting.title
                  }
                })
                // meeting.title = meeting.title + ' ' + vm.project.name
                firstintervenanttmp = meeting.firstintervenant_id
                vm.firstintervenants.forEach(function (firstintervenant) {
                  if (firstintervenant.id === firstintervenanttmp) {
                    meeting.title = meeting.title + ' ' + firstintervenant.firstname + ' ' + firstintervenant.lastname
                  }
                })
              })
              callback(formatMeetingsWithUrl(vm.meetingsProject))
            })
        }
      })
    },
    computed: {
      name: function () {
        if (!Array.isArray(this.project)) {
          return this.project.contact_firstname + ' ' + this.project.contact_lastname
        }
      }
    },
    watch: {
      'project': function () {
        // $('.Calendar').fullCalendar('refetchEvents')
        $('.Calendar').fullCalendar('gotoDate', moment('01-01-2000', 'DD-MM-YYYY'))
      },
      'meetingDeleted' () {
        $('.Calendar').fullCalendar('refetchEvents')
      },
      'selectedDay' (selectedDay) {
        if (selectedDay.origin !== 'calendar') {
          $('.Calendar').fullCalendar('gotoDate', moment(this.selectedDay.time, 'DD-MM-YYYY'))
        }
      }
    }
  }
</script>

<style>
  .CalendarPlanning .fc-header-toolbar{display: none;}
  .CalendarPlanning .fc-list-table td {padding: 2px 14px;}
</style>




// WEBPACK FOOTER //
// ProjectPlanning.vue?27ed7294